import extractLastOptions from "../../utils/extract-last-options";
import applyIncrement from "./apply-increment";
import getIncrement from "./get-increment";
import getNumber from "./get-number";
import replaceFnCommas from "./replace-fn-commas";

/**
 *
 * @param {String} input
 * @param {Number} index
 */
const processStagger = (input, index) => {
  const matches = input.match(/\/(.*?)\/+/g) || [];

  for (const match of matches) {
    const replaced = match.replace(/\s/g, "").trim();
    const clean = replaced.slice(1, -1);
    const prepared = replaceFnCommas(clean);
    const extracted = extractLastOptions(prepared);
    const options = extracted.get("options");
    const full = options ? extracted.get("rest") : prepared;

    const split = /** @type {Array<String>} */ (full.split(","));
    const hasStart = split.length > 1;
    const start = hasStart ? getNumber(split[0]) : 0;
    const value = hasStart ? split[1] : split[0];
    const increment = getIncrement(value);
    const number = applyIncrement(increment, start, index);

    input = input.replace(match, `${number}`);
  }

  return input;
}

export default processStagger;